import Vue from 'vue';
import get from 'lodash/get';

export default {
    namespaced: true,

    state: {},

    getters: {
        get(state) {
            return (path, defaultValue = null) => get(state, path, defaultValue);
        },
    },

    mutations: {
        setAll(state, config) {
            for (let [key, value] of Object.entries(config)) {
                Vue.set(state, key, value);
            }
        },
    },
};